import {
  SortBy,
  SortDirection,
  ProposalsSortBy,
  BlogSortBy
} from 'src/api/types';
import trns from './trns';

const checkIcon = 'shared/check-icon.svg';

export const sortOptionList = {
  SORT: {
    id: 'SORT',
    title: trns.sort
  },
  [`${SortBy.price}_${SortDirection.Asc}`]: {
    id: `${SortBy.price}_${SortDirection.Asc}`,
    title: trns.sortByPriceFromCheapToExpensive,
    icon: checkIcon
  },
  [`${SortBy.price}_${SortDirection.Desc}`]: {
    id: `${SortBy.price}_${SortDirection.Desc}`,
    title: trns.sortByPriceFromExpensiveToCheap,
    icon: checkIcon
  },
  [`${ProposalsSortBy.distance}_${SortDirection.Asc}`]: {
    id: `${ProposalsSortBy.distance}_${SortDirection.Asc}`,
    title: trns.sortByDistance,
    icon: checkIcon
  },
  [`${SortBy.name}_${SortDirection.Asc}`]: {
    id: `${SortBy.name}_${SortDirection.Asc}`,
    title: trns.sortByDistanceAlphabetBeginning,
    icon: checkIcon
  },
  [`${BlogSortBy.createDate}_${SortDirection.Asc}`]: {
    id: `${BlogSortBy.createDate}_${SortDirection.Asc}`,
    icon: checkIcon,
    title: trns.sortByCreateDateAsc
  },
  [`${BlogSortBy.views}_${SortDirection.Asc}`]: {
    id: `${BlogSortBy.views}_${SortDirection.Asc}`,
    icon: checkIcon,
    title: trns.sortByViewsAsc
  },
  [`${SortBy.name}_${SortDirection.Desc}`]: {
    id: `${SortBy.name}_${SortDirection.Desc}`,
    title: trns.sortByDistanceAlphabetEnd,
    icon: checkIcon
  },
  [`${SortBy.popularity}_${SortDirection.Desc}`]: {
    id: `${SortBy.popularity}_${SortDirection.Desc}`,
    icon: checkIcon,
    title: trns.sortByPopular
  },
  [`${SortBy.relevance}_${SortDirection.Desc}`]: {
    id: `${SortBy.relevance}_${SortDirection.Desc}`,
    icon: checkIcon,
    title: trns.sortByRelevance
  }
};
